import {
    Modal,
    TextField,
    IconButton,
    Box,
    Typography,
    Button,
    CircularProgress
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useState } from "react";

const CreateCategoryModal = ({ open, CreateAddCategory, onClose, onSave, HandleCreateSite, actions, adding, setAdding }) => {
    const [name, setName] = useState("");

    const handleSave = () => {
        // Optional: use `name` if you want to pass it
        // HandleCreateSite();   // ← This adds the blank category
        CreateAddCategory(name);
        // onClose();            // ← This closes the create modal
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    width: 500,
                    bgcolor: "#fff",
                    borderRadius: 2,
                    p: 4,
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                }}
            >
                {/* BACK BUTTON */}
                <IconButton onClick={onClose}>
                    <ArrowBackIcon />
                </IconButton>

                <Typography
                    variant="h5"
                    fontWeight="bold"
                    textAlign="center"
                    sx={{ mt: -4, mb: 3 }}
                >
                    Create new category
                </Typography>

                <Typography fontWeight="500" color="#666">
                    Category name
                </Typography>

                <TextField
                    fullWidth
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    sx={{ mt: 1, mb: 3 }}
                />

                <Button
                    fullWidth
                    variant="contained"
                    disabled={!name.trim() || adding}
                    onClick={handleSave}
                >
                    {adding ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Add"}
                </Button>
            </Box>
        </Modal>
    );
};

export default CreateCategoryModal;
